import React, { useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import orderBy from "lodash/orderBy";
import { AdverBlockContainerB } from "Containers/AdBlocksContainer";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import { RatingList, RatingRow } from "ComponentsUI/Rating";
import RatingTariffsContainerItem from "ComponentsUI/RatingTariffsContainerItem";
import queryString from "query-string";
import { replaceStaticHost, webpTransformer } from "Helpers/ImageManager";
import { NoContainer } from "ComponentsUI/Spacings";
import emotions from "Helpers/emotions";
import Button from "ComponentsUI/Button";
import OneClick from "Containers/OneClick";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { TARIFFS_FOR_CATALOG_V3 } from "Services/queries";
import { observer, inject } from "mobx-react";
import { useQuery } from "@apollo/client";
import { sendMetriks } from "Services/sendMetriks";

var Routes = require("Configs/routes");

const RatingTable = (props) => {
	const onClickButtonHandler = () => {
		props.ApplicationModel.providerModel.setProviderFeedback(props.match.params.providerName);
	};

	const onChangeUrl = (provider) => {
		let {
			ApplicationModel: { tariffsModel },
		} = props;
		tariffsModel.setProvider(provider);
	};

	const prepereRatingData = (data, period, type) => {
		if (period == undefined) return data;
		let periodType = period;
		let prepereData = [];
		data.forEach((provider, i) => {
			let orderTypesRatingArr = [];
			let rate = 0;
			provider.rating.order_types.forEach((rating) => {
				if (rating.order_type_id == type) {
					if (periodType == 1) {
						rate = rating.rating_3;
					}

					if (periodType == 2) {
						rate = rating.rating_6;
					}

					if (periodType == 3) {
						rate = rating.rating_12;
					}

					if (periodType == 4) {
						rate = rating.rating;
					}
					orderTypesRatingArr.push({
						counted: rating.review_all,
						order_type_id: rating.order_type_id,
						provider_answer_count: rating.provider_answer_count,
						rating: rate,
						rating_middle: rating.rating_middle,
						rating_minus: rating.rating_minus,
						rating_plus: rating.rating_plus,
						review_all: rating.review_all,
						review_kind: rating.review_kind,
					});
				}
			});
			let newRate = {
				id: provider.id,
				name: provider.name,
				url_name: provider.url_name,
				logo: replaceStaticHost(provider.logo),
				specifications: provider.specifications,
				rating: {
					expert: provider.rating.expert,
					order_types: orderTypesRatingArr,
				},
				vip_provider: provider.vip_provider,
				rate: rate,
				info: provider.info,
			};
			prepereData.push(newRate);
		});
		return prepereData;
	};

	const renderContentTable = (items) => {
		let text = props.text;
		let itemsB = items.map((o, index) => (
			<RatingRow key={o.id}>
				<RatingTariffsContainerItem
					webpTransformer={webpTransformer}
					emotions={emotions}
					linkComponent={<Link to={"/"} />}
					text={text}
					data={o}
					showPopUp={index === 0}
					index={index}
					key={index}
					windowSizes={props.windowSizes}
					pageName="rating"
				/>
			</RatingRow>
		));

		if (itemsB.length > 3) {
			itemsB.splice(3, 0, <OneClick key="pushedItem" />);
		} else {
			itemsB.push(<OneClick key="pushedItem" />);
		}

		return itemsB;
	};

	let windowSizes = props.windowSizes;
	let text = props.text;
	let providerIdList = props.items;
	let providerIDs = providerIdList.map((item) => item.id) || [];

	let tariffsQuery = useQuery(TARIFFS_FOR_CATALOG_V3, {
		variables: {
			providerIDs: providerIDs,
			limitByProvider: 3,
			providerJoin: true,
		},
		notifyOnNetworkStatusChange: true,
	});
	let tariffs = tariffsQuery?.data?.tariffsForCatalogV3;
	let connectTariffButton =
		props.ApplicationModel?.siteConfig?.settings?.connect_tariff_button?.rating || "connect";

	useEffect(() => {
		if (
			windowSizes.height &&
			connectTariffButton === "connect" &&
			!!tariffs?.data?.length &&
			tariffs?.data.find((tariff) => tariff?.provider?.vip_provider == 1) &&
			tariffs?.data.find(
				(tariff) => tariff?.provider?.provider_settings?.tariffs?.value === "button_text"
			)
		) {
			sendMetriks("OPEN_NEW_TEXT");
		}
	}, [tariffs?.data, windowSizes.height]);

	if (!props.items.length) {
		let feedbackUrl = generateUrl(Routes.AddReview.route, {
			regionUrl: props.match.params.regionUrl,
		});
		return (
			<Container>
				<Row>
					<Col
						lg={{ size: 4, offset: 4 }}
						md={{ size: 4, offset: 4 }}
						sm={{ size: 4, offset: 4 }}
						xs={{ size: 6, offset: 3 }}
					>
						<EmptyStub
							header={text.NO_PROVIDERS_HEADER}
							text={text.NO_PROVIDERS_TEXT}
							icon={
								<span
									className="icon48 icon-balance"
									style={{
										fontSize: "48px",
										color: "#5812fe",
									}}
								/>
							}
							button={
								<Button
									stub={false}
									typeText="big"
									component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
									size={"middle"}
									status={"purple"}
									datatest="main_allreviews_button"
									fullWidth={true}
									onClick={() => onClickButtonHandler()}
								>
									{text.ratingLeaveReview}
								</Button>
							}
						/>
					</Col>
				</Row>
				<OneClick />
			</Container>
		);
	}
	let type_id = 1;
	let period = 4;
	const {
		location: { search },
	} = props;
	const getParams = queryString.parse(search);
	if (getParams.period) {
		period = parseInt(getParams.period);
	}
	if (getParams.service) {
		type_id = parseInt(getParams.service);
	}
	let newData = prepereRatingData(props.items, period, type_id);
	newData = orderBy(newData, "rate", "desc");
	let items = newData.map((provider, i) => {
		let data = {
			id: provider.id,
			name: provider.name,
			url_name: provider.url_name,
			logo: replaceStaticHost(provider.logo),
			specifications: provider.specifications,
			position: i + 1,
			rating: {
				...provider.rating.order_types.find((p) => p.order_type_id == type_id),
			},
			urlConnect: "",
			linkCard: generateUrl(Routes.ProviderDetails.route, {
				regionUrl: props.match.params.regionUrl,
				providerName: provider.url_name,
			}),
			linkTariffs: generateUrl(Routes.ProviderRates.route, {
				regionUrl: props.match.params.regionUrl,
				providerName: provider.url_name,
			}),
			linkConnect: (
				<a
					className="_purple"
					onClick={() => props.onProviderConnect(provider)}
					datatest="raiting_connect_button"
					style={{
						color: "#8e87a3",
						cursor: "pointer",
						fontSize: "14px",
						fontFamily: "MuseoSansCyrl-500",
						borderBottom: "1px dashed #8e87a3",
						letterSpacing: "2px",
					}}
				>
					{`${text.CHECK_COVERAGE} ${provider.name}`}
				</a>
			),
			info: provider.info,
			tariffs: tariffs?.data?.filter((item) => {
				if (item.provider.id === provider.id) return true;
			}),
		};
		return data;
	});

	return <RatingList>{renderContentTable(items)}</RatingList>;
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(RatingTable))));
